// Start:: Importing Middleware
import auth from "../middleware/auth.js";
import Authentication from "../pages/Authentication.vue";
// End:: Importing Middleware

// Start:: Importing Router Components
import Vue from "vue";
import VueRouter from "vue-router";
// End:: Importing Router Components

// ============== Start:: Home Page Route
import AppContentWrapper from "../pages/AppContentWrapper.vue";
import HomePage from "../pages/HomePage.vue";
// ============== End:: Home Page Route
// ============== Start:: Branches Routes
import BranchesHome from "../views/Cruds/Branches/Home.vue";
import AllBranches from "../views/Cruds/Branches/ShowAll.vue";
import CreateBranches from "../views/Cruds/Branches/Create.vue";
import ShowBranches from "../views/Cruds/Branches/Show.vue";
import EditBranches from "../views/Cruds/Branches/Edit.vue";
// ============== End:: Branches Routes
// ============== Start:: Roles Routes
import RolesHome from "../views/Cruds/Roles/Home.vue";
import AllRoles from "../views/Cruds/Roles/ShowAll.vue";
import EditRole from "../views/Cruds/Roles/Edit.vue";
import CreateRole from "../views/Cruds/Roles/Create.vue";
// ============== End:: Roles Routes

// ============== Start:: Financial Reports Routes
import FinancialReportsHome from "../views/Cruds/FinancialReports/Home.vue";
import AllFinancialReports from "../views/Cruds/FinancialReports/ShowAll.vue";
import ShowFinancialReport from "../views/Cruds/FinancialReports/Show.vue";
// ============== End:: Financial Reports Routes

// ============== Start:: FinancialfinshedReports Routes
import FinancialFinshedReportsHome from "../views/Cruds/FinancialFinshedReports/Home.vue";
import AllFinancialFinshedReports from "../views/Cruds/FinancialFinshedReports/ShowAll.vue";
import ShowFinancialFinshedReport from "../views/Cruds/FinancialFinshedReports/Show.vue";
// ============== End:: FinancialfinshedReports Routes

// ============== Start:: FinancialOrders Routes
import FinancialOrdersHome from "../views/Cruds/FinancialOrders/Home.vue";
import AllFinancialOrders from "../views/Cruds/FinancialOrders/ShowAll.vue";
// ============== End:: FinancialOrders Routes

// ============== Start:: FinancialPack Routes
import FinancialPackHome from "../views/Cruds/FinancialPack/Home.vue";
import AllFinancialPack from "../views/Cruds/FinancialPack/ShowAll.vue";
// ============== End:: FinancialPack Routes

// ============== Start:: AppRates Routes
import AppRatesHome from "../views/Cruds/AppRates/Home.vue";
import AllAppRates from "../views/Cruds/AppRates/ShowAll.vue";
// ============== End:: AppRates Routes

// ============== Start:: StoreRates Routes
import StoreRatesHome from "../views/Cruds/StoreRates/Home.vue";
import AllStoreRates from "../views/Cruds/StoreRates/ShowAll.vue";
// ============== End:: StoreRates Routes

// ============== Start:: Admins Routes
import ShowAdmin from "../views/Cruds/Admins/Show.vue";
import EditAdmin from "../views/Cruds/Admins/Edit.vue";
import CreateAdmin from "../views/Cruds/Admins/Create.vue";
import AllAdmins from "../views/Cruds/Admins/ShowAll.vue";
import AdminsHome from "../views/Cruds/Admins/Home.vue";
// ============== End:: Admins Routes

// ============== Start:: login Routes
import LoginForm from "../views/Auth/LoginForm.vue";
import ResetPasswordEmailForm from "../views/Auth/ResetPasswordEmailForm.vue";
import EmailVerificationForm from "../views/Auth/EmailVerificationForm.vue";
import ChangePhoneNumberForm from "../views/Auth/ChangePhoneNumber.vue";
import ResetPasswordForm from "../views/Auth/ResetPasswordForm.vue";
// ============== End:: login Routes

// ============== Start:: Contact Messages Routes
import ContactMessagesHome from "../views/Cruds/ContactMessages/Home.vue";
import AllContactMessages from "../views/Cruds/ContactMessages/ShowAll.vue";
import showMessage from "../views/Cruds/ContactMessages/Show.vue";
// ============== End:: Contact Messages Routes

// ============== Start:: App Content Routes
import AppContentHome from "../views/Cruds/AppContent/Home.vue";
import GeneralSettings from "../views/Cruds/AppSettings/GeneralSettings.vue";
import AppSettings from "../views/Cruds/AppSettings/AppSettings.vue";
import AboutUs from "../views/Cruds/AppContent/AboutUs.vue";
import Faq from "../views/Cruds/AppContent/Faq.vue";
import Terms from "../views/Cruds/AppContent/Terms.vue";
import DeleteAccount from "../views/Cruds/AppContent/DeleteAccount.vue";
import PrivacyPolicy from "../views/Cruds/AppContent/PrivacyPolicy.vue";
import TermsProvider from "../views/Cruds/AppContent/TermsProvider.vue";
// ============== End:: App Content Routes

// Start:: Questiions Router Components
import questionsHome from "../views/Cruds/FAQ/Home.vue";
import Allquestions from "../views/Cruds/FAQ/ShowAll.vue";
import Createquestions from "../views/Cruds/FAQ/Create.vue";
import Editquestions from "../views/Cruds/FAQ/Edit.vue";
// End:: Questions Router Components

// ============ Start:: Users Routes
import UsersHome from "../views/Cruds/Users/Home.vue";
import AllUsers from "../views/Cruds/Users/ShowAll.vue";
import ShowUsers from "../views/Cruds/Users/Show.vue";
// ============ End:: Users Routes

// ============ Start:: User Subscriptions Routes
import UserSubscriptionsHome from "../views/Cruds/UserSubscriptions/Home.vue";
import AllUserSubscriptions from "../views/Cruds/UserSubscriptions/ShowAll.vue";
import ShowUserSubscription from "../views/Cruds/UserSubscriptions/Show.vue";
import UserSubscriptionHistory from "../views/Cruds/UserSubscriptions/UserHistory.vue";
// ============ End:: User Subscriptions Routes

// ============ Start:: Store Payments Routes
import StorePaymentsHome from "../views/Cruds/StorePayments/Home.vue";
import AllStorePayments from "../views/Cruds/StorePayments/ShowAll.vue";
import ShowStorePayment from "../views/Cruds/StorePayments/Show.vue";
// ============ End:: Store Payments Routes

// ============== Start:: Ads Routes
import AdsHome from "../views/Cruds/Ads/Home.vue";
import AllAds from "../views/Cruds/Ads/ShowAll.vue";
import CreateAds from "../views/Cruds/Ads/Create.vue";
import ShowAds from "../views/Cruds/Ads/Show.vue";
import EditAds from "../views/Cruds/Ads/Edit.vue";
// ============== End:: Ads Routes

// ============== Start:: Products Routes
import ProductsHome from "../views/Cruds/Products/Home.vue";
import AllProducts from "../views/Cruds/Products/ShowAll.vue";
import CreateProducts from "../views/Cruds/Products/Create.vue";
import ShowProducts from "../views/Cruds/Products/Show.vue";
import EditProducts from "../views/Cruds/Products/Edit.vue";
// ============== End:: Products Routes

// ============== Start:: Cities Routes
import CitiesHome from "../views/Cruds/Cities/Home.vue";
import AllCities from "../views/Cruds/Cities/ShowAll.vue";
import CreateCities from "../views/Cruds/Cities/Create.vue";
import ShowCities from "../views/Cruds/Cities/Show.vue";
import EditCities from "../views/Cruds/Cities/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: Comments Routes
import CommentsHome from "../views/Cruds/Comments/Home.vue";
import AllComments from "../views/Cruds/Comments/ShowAll.vue";
// ============== End:: Comments Routes

// ============== Start:: Withdraw Routes
import WithdrawHome from "../views/Cruds/Withdraw/Home.vue";
import AllWithdraw from "../views/Cruds/Withdraw/ShowAll.vue";
import ShowWithdraw from "../views/Cruds/Withdraw/Show.vue";
// ============== End:: Withdraw Routes

// ============== Start:: Interests Routes
import InterestsHome from "../views/Cruds/Interests/Home.vue";
import AllInterests from "../views/Cruds/Interests/ShowAll.vue";
import CreateInterests from "../views/Cruds/Interests/Create.vue";
import ShowInterests from "../views/Cruds/Interests/Show.vue";
import EditInterests from "../views/Cruds/Interests/Edit.vue";
// ============== End:: Interests Routes

// ============== Start:: Districts Routes
import DistrictsHome from "../views/Cruds/Districts/Home.vue";
import AllDistricts from "../views/Cruds/Districts/ShowAll.vue";
import CreateDistricts from "../views/Cruds/Districts/Create.vue";
import ShowDistricts from "../views/Cruds/Districts/Show.vue";
import EditDistricts from "../views/Cruds/Districts/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: Regions Routes
import RegionsHome from "../views/Cruds/Regions/Home.vue";
import AllRegions from "../views/Cruds/Regions/ShowAll.vue";
import CreateRegions from "../views/Cruds/Regions/Create.vue";
import ShowRegions from "../views/Cruds/Regions/Show.vue";
import EditRegions from "../views/Cruds/Regions/Edit.vue";
// ============== End:: Regions Routes

// ============== Start:: Services Routes
import ServicesHome from "../views/Cruds/Services/Home.vue";
import AllServices from "../views/Cruds/Services/ShowAll.vue";
import CreateServices from "../views/Cruds/Services/Create.vue";
import ShowServices from "../views/Cruds/Services/Show.vue";
import EditServices from "../views/Cruds/Services/Edit.vue";
// ============== End:: Services Routes

// ============== Start:: Workplaces Routes
import WorkplacesHome from "../views/Cruds/Workplaces/Home.vue";
import AllWorkplaces from "../views/Cruds/Workplaces/ShowAll.vue";
import CreateWorkplaces from "../views/Cruds/Workplaces/Create.vue";
import ShowWorkplaces from "../views/Cruds/Workplaces/Show.vue";
import EditWorkplaces from "../views/Cruds/Workplaces/Edit.vue";
// ============== End:: Workplaces Routes

// ============== Start:: WalletRequests Routes
import RequestWalletsHome from "../views/Cruds/WalletRequests/Home.vue";
import AllRequestWallets from "../views/Cruds/WalletRequests/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: WalletHistory Routes
import WalletHistoryHome from "../views/Cruds/WalletHistory/Home.vue";
import AllWalletHistory from "../views/Cruds/WalletHistory/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: Reasons Routes
import ReasonsHome from "../views/Cruds/Reasons/Home.vue";
import AllReasons from "../views/Cruds/Reasons/ShowAll.vue";
import CreateReasons from "../views/Cruds/Reasons/Create.vue";
import ShowReasons from "../views/Cruds/Reasons/Show.vue";
import EditReasons from "../views/Cruds/Reasons/Edit.vue";
// ============== End:: Reasons Routes

// ============== Start:: Banks Routes
// import BanksHome from "../views/Cruds/Banks/Home.vue";
// import AllBanks from "../views/Cruds/Banks/ShowAll.vue";
// import CreateBanks from "../views/Cruds/Banks/Create.vue";
// import ShowBanks from "../views/Cruds/Banks/Show.vue";
// import EditBanks from "../views/Cruds/Banks/Edit.vue";
// ============== End:: Banks Routes

// ============== Start:: Packages Routes
import PackagesHome from "../views/Cruds/Packages/Home.vue";
import AllPackages from "../views/Cruds/Packages/ShowAll.vue";
import CreatePackages from "../views/Cruds/Packages/Create.vue";
import ShowPackages from "../views/Cruds/Packages/Show.vue";
import EditPackages from "../views/Cruds/Packages/Edit.vue";
// ============== End:: Packages Routes

// ============== Start:: Subscriptions Routes
import SubscriptionsHome from "../views/Cruds/Subscriptions/Home.vue";
import AllSubscriptions from "../views/Cruds/Subscriptions/ShowAll.vue";
// ============== End:: Subscriptions Routes

// ============== Start:: orders Routes
import ordersHome from "../views/Cruds/Orders/Home.vue";
import Allorders from "../views/Cruds/Orders/ShowAll.vue";
import Showorders from "../views/Cruds/Orders/Show.vue";
// ============== End:: orders Routes

// ============== Start:: UserRequests Routes =================
import UserRequestsHome from "../views/Cruds/UserRequests/Home.vue";
import AllUserRequests from "../views/Cruds/UserRequests/ShowAll.vue";
import ShowUserRequests from "../views/Cruds/UserRequests/Show.vue";
// ============== Start:: UserRequests Routes =================

// ============== Start:: Providers Routes
import ProvidersHome from "../views/Cruds/Providers/Home.vue";
import AllProviders from "../views/Cruds/Providers/ShowAll.vue";
import CreateProviders from "../views/Cruds/Providers/Create.vue";
import ShowProviders from "../views/Cruds/Providers/Show.vue";
import EditProviders from "../views/Cruds/Providers/Edit.vue";
// ============== End:: Providers Routes

// ============== Start:: Stables Routes
import StablesHome from "../views/Cruds/Stables/Home.vue";
import AllStables from "../views/Cruds/Stables/ShowAll.vue";
import CreateStables from "../views/Cruds/Stables/Create.vue";
import ShowStables from "../views/Cruds/Stables/Show.vue";
import EditStables from "../views/Cruds/Stables/Edit.vue";
// ============== End:: Stables Routes

// ============== Start:: RoomRent Routes
import RoomRentHome from "../views/Cruds/RoomRent/Home.vue";
import AllRoomRent from "../views/Cruds/RoomRent/ShowAll.vue";
import ShowRoomRent from "../views/Cruds/RoomRent/Show.vue";
// ============== End:: RoomRent Routes

// ============== Start:: HorsePurchase Routes
import HorsePurchaseHome from "../views/Cruds/HorsePurchase/Home.vue";
import AllHorsePurchase from "../views/Cruds/HorsePurchase/ShowAll.vue";
import ShowHorsePurchase from "../views/Cruds/HorsePurchase/Show.vue";
// ============== End:: HorsePurchase Routes

// ============== Start:: HorseRent Routes
import HorseRentHome from "../views/Cruds/HorseRent/Home.vue";
import AllHorseRent from "../views/Cruds/HorseRent/ShowAll.vue";
import ShowHorseRent from "../views/Cruds/HorseRent/Show.vue";
// ============== End:: HorseRent Routes
// ============== Start:: OtherService Routes
import OtherServiceHome from "../views/Cruds/OtherService/Home.vue";
import AllOtherService from "../views/Cruds/OtherService/ShowAll.vue";
import ShowOtherService from "../views/Cruds/OtherService/Show.vue";
// ============== End:: OtherService Routes

// ============== Start:: ProductOrders Routes
import ProductOrdersHome from "../views/Cruds/ProductOrders/Home.vue";
import AllProductOrders from "../views/Cruds/ProductOrders/ShowAll.vue";
import ShowProductOrders from "../views/Cruds/ProductOrders/Show.vue";
// ============== End:: ProductOrders Routes
// ============== Start:: CarrierService  Routes
import CarrierServiceHome from "../views/Cruds/CarrierService/Home.vue";
import AllCarrierService from "../views/Cruds/CarrierService/ShowAll.vue";
import ShowCarrierService from "../views/Cruds/CarrierService/Show.vue";
// ============== End:: CarrierService Routes
// ============== Start:: Chosen Routes
import ChosenHome from "../views/Cruds/Chosen/Home.vue";
import AllChosen from "../views/Cruds/Chosen/ShowAll.vue";
import CreateChosen from "../views/Cruds/Chosen/Create.vue";
import ShowChosen from "../views/Cruds/Chosen/Show.vue";
import EditChosen from "../views/Cruds/Chosen/Edit.vue";
// ============== End:: Providers Routes

// ============== Start:: All Notifications Routes
import AllNotifications from "../views/Cruds/Notifications/ShowAll.vue";
import NotificationsHome from "../views/Cruds/Notifications/Home.vue";
import CreateNotifications from "../views/Cruds/Notifications/Create.vue";
import ShowNotificationsTable from "../views/Cruds/Notifications/Show.vue";
// import ShowNotificationsIcon from "../views/Cruds/Notifications/Test.vue";
import ShowAllNotifications from "../views/Cruds/Notifications/ShowAllNotifications.vue";

// ============== End:: All Notifications Routes

// ================== Start:: Clients Routes
import ClientsHome from "../views/Cruds/Clients/Home.vue";
import AllClients from "../views/Cruds/Clients/ShowAll.vue";
import CreateClients from "../views/Cruds/Clients/Create.vue";
import ShowClients from "../views/Cruds/Clients/Show.vue";
// ================= End:: Clients Routes

// ================== Start:: Owners Routes
import OwnersHome from "../views/Cruds/Owners/Home.vue";
import AllOwners from "../views/Cruds/Owners/ShowAll.vue";
import ShowOwners from "../views/Cruds/Owners/Show.vue";
// ================= End:: Owners Routes
// ================== Start:: Workers Routes
import WorkersHome from "../views/Cruds/Workers/Home.vue";
import AllWorkers from "../views/Cruds/Workers/ShowAll.vue";
import CreateWorkers from "../views/Cruds/Workers/Create.vue";
import ShowWorkers from "../views/Cruds/Workers/Show.vue";
// ================= End:: Workers Routes

// ================== Start:: DeliveryMen Routes
import DeliveryMenHome from "../views/Cruds/DeliveryMen/Home.vue";
import AllDeliveryMen from "../views/Cruds/DeliveryMen/ShowAll.vue";
import CreateDeliveryMen from "../views/Cruds/DeliveryMen/Create.vue";
import ShowDeliveryMen from "../views/Cruds/DeliveryMen/Show.vue";
import EditDeliveryMen from "../views/Cruds/DeliveryMen/Edit.vue";
// ================= End:: DeliveryMen Routes

// ================== Start:: Sliders Routes
import SlidersHome from "../views/Cruds/Sliders/Home.vue";
import AllSliders from "../views/Cruds/Sliders/ShowAll.vue";
import CreateSliders from "../views/Cruds/Sliders/Create.vue";
import ShowSliders from "../views/Cruds/Sliders/Show.vue";
import EditSliders from "../views/Cruds/Sliders/Edit.vue";
// ================= End:: Sliders Routes

//=============== Start:: Order Desiginer Routes
import OrdersRequestsHome from "../views/Cruds/OrdersRequests/Home.vue";
import AllOrdersRequests from "../views/Cruds/OrdersRequests/ShowAll.vue";
import ShowOrdersRequests from "../views/Cruds/OrdersRequests/Show.vue";
//============== End:: Order Desiginer Routes

//============== Start:: Colors Routes
import ColorsHome from "../views/Cruds/Colors/Home.vue";
import AllColors from "../views/Cruds/Colors/ShowAll.vue";
import CreateColors from "../views/Cruds/Colors/Create.vue";
import EditColors from "../views/Cruds/Colors/Edit.vue";
//============== End:: Colors Routes

//============== Start:: Breeds Routes
import BreedsHome from "../views/Cruds/Breeds/Home.vue";
import AllBreeds from "../views/Cruds/Breeds/ShowAll.vue";
import CreateBreeds from "../views/Cruds/Breeds/Create.vue";
import EditBreeds from "../views/Cruds/Breeds/Edit.vue";
//============== End:: Breeds Routes

//============== Start:: ServiceTypes Routes
import ServiceTypesHome from "../views/Cruds/ServiceTypes/Home.vue";
import AllServiceTypes from "../views/Cruds/ServiceTypes/ShowAll.vue";
import CreateServiceTypes from "../views/Cruds/ServiceTypes/Create.vue";
import EditServiceTypes from "../views/Cruds/ServiceTypes/Edit.vue";
//============== End:: ServiceTypes Routes

//============== Start:: ServiceTypes Requests Routes
import ServiceTypesRequestsHome from "../views/Cruds/ServiceTypesRequests/Home.vue";
import AllServiceTypesRequests from "../views/Cruds/ServiceTypesRequests/ShowAll.vue";
import ShowServiceTypesRequests from "../views/Cruds/ServiceTypesRequests/Show.vue";
//============== End:: ServiceTypes Requests Routes

// ============== Start:: MainCategories Routes
import CategoriesHome from "../views/Cruds/MainCategories/Home.vue";
import AllCategories from "../views/Cruds/MainCategories/ShowAll.vue";
import CreateCategories from "../views/Cruds/MainCategories/Create.vue";
import EditCategories from "../views/Cruds/MainCategories/Edit.vue";
import ShowCategories from "../views/Cruds/MainCategories/Show.vue";
// ============== End:: MainCategories Routes

// ============== Start:: JoinDeliveries Routes
import join_deliveriesHome from "../views/Cruds/JoinDeliveries/Home.vue";
import Alljoin_deliveries from "../views/Cruds/JoinDeliveries/ShowAll.vue";
import Showjoin_deliveries from "../views/Cruds/JoinDeliveries/Show.vue";
// ============== End:: JoinDeliveries Routes
// ============== Start:: join_providers Routes
import join_providersHome from "../views/Cruds/JoinProviders/Home.vue";
import Alljoin_providers from "../views/Cruds/JoinProviders/ShowAll.vue";
import Showjoin_providers from "../views/Cruds/JoinProviders/Show.vue";
// ============== End:: join_providers Routes
// ============== Start:: join_stables Routes
import join_stablesHome from "../views/Cruds/JoinStables/Home.vue";
import Alljoin_stables from "../views/Cruds/JoinStables/ShowAll.vue";
import Showjoin_stables from "../views/Cruds/JoinStables/Show.vue";
// ============== End:: join_stables Routes
// ============== Start:: update_provider Routes
import update_providerHome from "../views/Cruds/UpdateProvider/Home.vue";
import Allupdate_provider from "../views/Cruds/UpdateProvider/ShowAll.vue";
import Showupdate_provider from "../views/Cruds/UpdateProvider/Show.vue";
// ============== End:: update_provider Routes
// ============== Start:: update_delivery Routes
import update_deliveryHome from "../views/Cruds/UpdateDelivery/Home.vue";
import Allupdate_delivery from "../views/Cruds/UpdateDelivery/ShowAll.vue";
import Showupdate_delivery from "../views/Cruds/UpdateDelivery/Show.vue";
// ============== End:: update_delivery Routes

// ============== Start:: SubCategories Routes
import SubCategoriesHome from "../views/Cruds/SubCategories/Home.vue";
import AllSubCategories from "../views/Cruds/SubCategories/ShowAll.vue";
import CreateSubCategories from "../views/Cruds/SubCategories/Create.vue";
import EditSubCategories from "../views/Cruds/SubCategories/Edit.vue";
import ShowSubCategories from "../views/Cruds/SubCategories/Show.vue";
// ============== End:: SubCategories Routes
// ============== Start:: Coupons Routes
import CouponsHome from "../views/Cruds/Coupons/Home.vue";
import AllCoupons from "../views/Cruds/Coupons/ShowAll.vue";
import CreateCoupons from "../views/Cruds/Coupons/Create.vue";
import ShowCoupons from "../views/Cruds/Coupons/Show.vue";
import EditCoupons from "../views/Cruds/Coupons/Edit.vue";
// ============== End:: Coupons Routes

// ============== Start:: Capacities Routes
import CapacitiesHome from "../views/Cruds/Capacities/Home.vue";
import AllCapacities from "../views/Cruds/Capacities/ShowAll.vue";
import CreateCapacities from "../views/Cruds/Capacities/Create.vue";
import ShowCapacities from "../views/Cruds/Capacities/Show.vue";
import EditCapacities from "../views/Cruds/Capacities/Edit.vue";
// ============== End:: Capacities Routes
// ============== Start:: Additions Routes
import AdditionsHome from "../views/Cruds/Additions/Home.vue";
import AllAdditions from "../views/Cruds/Additions/ShowAll.vue";
import CreateAdditions from "../views/Cruds/Additions/Create.vue";
import ShowAdditions from "../views/Cruds/Additions/Show.vue";
import EditAdditions from "../views/Cruds/Additions/Edit.vue";
// ============== End:: Additions Routes

// ============== Start:: ResidentialAdd Routes
import ResidentialAddHome from "../views/Cruds/ResidentialAdd/Home.vue";
import AllResidentialAdd from "../views/Cruds/ResidentialAdd/ShowAll.vue";
import CreateResidentialAdd from "../views/Cruds/ResidentialAdd/Create.vue";
import ShowResidentialAdd from "../views/Cruds/ResidentialAdd/Show.vue";
import EditResidentialAdd from "../views/Cruds/ResidentialAdd/Edit.vue";
// ============== End:: ResidentialAdd Routes

// ============== Start:: Managements Routes
import ManagementsHome from "../views/Cruds/Managements/Home.vue";
import AllManagements from "../views/Cruds/Managements/ShowAll.vue";
import CreateManagements from "../views/Cruds/Managements/Create.vue";
import EditManagements from "../views/Cruds/Managements/Edit.vue";
import ShowManagements from "../views/Cruds/Managements/Show.vue";
// ============== End:: Managements Routes

// ============== Start:: Forbidden Route
import ForbiddenPage from "../pages/ForbiddenPage.vue";
// ============== End:: Forbidden Route

// ============== Start:: Not Found Route
import NotFoundPage from "../pages/NotFound.vue";
// ============== End:: Not Found Route

// End:: Importing Router Components

Vue.use(VueRouter);
const routes = [
  // ***************** Start:: Auth Routes Config
  {
    path: "/",
    component: Authentication,
    children: [
      {
        path: "/",
        component: LoginForm,
        name: "LoginForm",
      },
      {
        path: "/reset-password-email",
        name: "ResetPasswordEmailForm",
        component: ResetPasswordEmailForm,
      },
      {
        path: "/email-verification/:verification_type",
        name: "EmailVerificationForm",
        component: EmailVerificationForm,
      },
      {
        path: "/chang-phone-number",
        name: "ChangePhoneNumberForm",
        component: ChangePhoneNumberForm,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordForm",
        component: ResetPasswordForm,
      },
    ],
  },
  // ***************** End:: Auth Routes Config

  // ***************** Start:: Content Routes Config
  {
    path: "/home",
    component: AppContentWrapper,
    children: [
      // Start:: Home Route Config
      {
        path: "/home",
        component: HomePage,
        meta: {
          middleware: [auth],
        },
      },
      // End:: Home Route Config

      // Start:: Contact Messages Routes Config
      {
        path: "/contact-messages",
        name: "ContactMessagesHome",
        component: ContactMessagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllContactMessages",
            component: AllContactMessages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts index",
                subject: "contacts",
              },
            },
          },
          {
            path: "show/:id",
            name: "showMessage",
            component: showMessage,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts show",
                subject: "contacts",
              },
            },
          },
        ],
      },
      // End:: Contact Messages Routes Config

      // Start:: App Content Routes Config
      {
        path: "/app-content",
        name: "AppContentHome",
        component: AppContentHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "about-us",
            name: "AboutUs",
            component: AboutUs,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "faq",
            name: "Faq",
            component: Faq,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "terms",
            name: "Terms",
            component: Terms,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "policy",
            name: "PrivacyPolicy",
            component: PrivacyPolicy,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "provider-terms",
            name: "TermsProvider",
            component: TermsProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "delete-account",
            name: "DeleteAccount",
            component: DeleteAccount,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
        ],
      },
      // End:: App Content Routes Config

      // Start:: AllFinancialOrders Routes Config
      {
        path: "/financialorders",
        name: "FinancialOrdersHome",
        component: FinancialOrdersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialOrders",
            component: AllFinancialOrders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles index",
                subject: "roles",
              },
            },
          },
        ],
      },
      {
        path: "/financialpack",
        name: "FinancialPackHome",
        component: FinancialPackHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialPack",
            component: AllFinancialPack,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles index",
                subject: "roles",
              },
            },
          },
        ],
      },

      // Start:: Financial Reports Routes Config
      {
        path: "/financial-reports",
        name: "FinancialReportsHome",
        component: FinancialReportsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialReports",
            component: AllFinancialReports,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "invoices index",
                subject: "invoices",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowFinancialReport",
            component: ShowFinancialReport,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "invoices show",
                subject: "invoices",
              },
            },
          },
        ],
      },

      {
        path: "/financial-finished-reports",
        name: "FinancialFinshedReportsHome",
        component: FinancialFinshedReportsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialFinshedReports",
            component: AllFinancialFinshedReports,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "invoices index",
                subject: "invoices",
              },
            },
          },
        ],
      },
      // End:: Financial Reports Routes Config

      // Start:: Roles Routes Config
      {
        path: "/roles",
        name: "RolesHome",
        component: RolesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRoles",
            component: AllRoles,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles index",
                subject: "roles",
              },
            },
          },
          {
            path: "create",
            name: "CreateRole",
            component: CreateRole,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles create",
                subject: "roles",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRole",
            component: EditRole,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles edit",
                subject: "roles",
              },
            },
          },
        ],
      },
      // End:: Roles Routes Config

      // Start:: Admins Routes Config
      {
        path: "/admins",
        name: "AdminsHome",
        component: AdminsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdmins",
            component: AllAdmins,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins index",
                subject: "admins",
              },
            },
          },
          {
            path: "create",
            name: "CreateAdmin",
            component: CreateAdmin,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins create",
                subject: "admins",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAdmin",
            component: EditAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins edit",
                subject: "admins",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAdmin",
            component: ShowAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins show",
                subject: "admins",
              },
            },
          },
        ],
      },
      // End:: Admins Routes Config

      // Start:: users Routes Config
      {
        path: "/users",
        name: "UsersHome",
        component: UsersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUsers",
            component: AllUsers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowUsers",
            component: ShowUsers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users show",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: users Routes Config

      // Start:: User Subscriptions Routes Config
      {
        path: "/user-subscriptions",
        name: "UserSubscriptionsHome",
        component: UserSubscriptionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUserSubscriptions",
            component: AllUserSubscriptions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "usersubscriptions index",
                subject: "usersubscriptions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowUserSubscription",
            component: ShowUserSubscription,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "usersubscriptions show",
                subject: "usersubscriptions",
              },
            },
          },
          {
            path: "history/:userId",
            name: "UserSubscriptionHistory",
            component: UserSubscriptionHistory,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "usersubscriptions show",
                subject: "usersubscriptions",
              },
            },
          },
        ],
      },
      // End:: User Subscriptions Routes Config

      // Start:: Store Payments Routes Config
      {
        path: "/store-payments",
        name: "StorePaymentsHome",
        component: StorePaymentsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllStorePayments",
            component: AllStorePayments,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "announcements index",
                subject: "announcements",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowStorePayment",
            component: ShowStorePayment,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "announcements show",
                subject: "announcements",
              },
            },
          },
        ],
      },
      // End:: Store Payments Routes Config

      // Start:: products  Config
      {
        path: "/products",
        name: "products",
        component: ProductsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allproducts",
            component: AllProducts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products index",
                subject: "products",
              },
            },
          },
          {
            path: "create",
            name: "Createproducts",
            component: CreateProducts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products create",
                subject: "products",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editproducts",
            component: EditProducts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products edit",
                subject: "products",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showproducts",
            component: ShowProducts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products show",
                subject: "products",
              },
            },
          },
        ],
      },
      // End:: products Config

      // Start:: orders  Config
      {
        path: "/orders",
        name: "orders",
        component: ordersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allorders",
            component: Allorders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders index",
                subject: "orders",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showorders",
            component: Showorders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders show",
                subject: "orders",
              },
            },
          },
        ],
      },
      // End:: orders Config

      // Start:: cities  Config
      {
        path: "/cities",
        name: "cities",
        component: CitiesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allcities",
            component: AllCities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities index",
                subject: "cities",
              },
            },
          },
          {
            path: "create",
            name: "Createcities",
            component: CreateCities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities create",
                subject: "cities",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editcities",
            component: EditCities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities edit",
                subject: "cities",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showcities",
            component: ShowCities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities show",
                subject: "cities",
              },
            },
          },
        ],
      },
      // End:: cities Config

      // Start:: comments Config
      {
        path: "/comments",
        name: "comments",
        component: CommentsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllComments",
            component: AllComments,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reviews index",
                subject: "reviews",
              },
            },
          },
        ],
      },
      // End:: comments Config

      // Start:: withdraw Config
      {
        path: "/withdraw",
        name: "withdraw",
        component: WithdrawHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllWithdraw",
            component: AllWithdraw,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "withdraw-requests index",
                subject: "withdraw-requests",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowWithdraw",
            component: ShowWithdraw,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "withdraw-requests show",
                subject: "withdraw-requests",
              },
            },
          },
        ],
      },
      // End:: withdraw Config

      // Start:: interests Config
      {
        path: "/interests",
        name: "interests",
        component: InterestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllInterests",
            component: AllInterests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "interests index",
                subject: "interests",
              },
            },
          },
          {
            path: "create",
            name: "CreateInterests",
            component: CreateInterests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "interests create",
                subject: "interests",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditInterests",
            component: EditInterests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "interests edit",
                subject: "interests",
              },
            },
          },
          // {
          //   path: "show/:id",
          //   name: "ShowInterests",
          //   component: ShowInterests,
          //   props: true,
          //   meta: {
          //     middleware: [auth],
          //     requiresPermission: {
          //       action: "interests show",
          //       subject: "interests",
          //     },
          //   },
          // },
        ],
      },
      // End:: interests Config

      // Start:: districts  Config
      {
        path: "/districts",
        name: "districts",
        component: DistrictsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alldistricts",
            component: AllDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts index",
                subject: "districts",
              },
            },
          },
          {
            path: "create",
            name: "Createdistricts",
            component: CreateDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts create",
                subject: "districts",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editdistricts",
            component: EditDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts edit",
                subject: "districts",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showdistricts",
            component: ShowDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts show",
                subject: "districts",
              },
            },
          },
        ],
      },
      // End:: districts Config

      // Start:: RegionsHome  Config
      {
        path: "/areas",
        name: "regions",
        component: RegionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRegions",
            component: AllRegions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions index",
                subject: "regions",
              },
            },
          },
          {
            path: "create",
            name: "CreateRegions",
            component: CreateRegions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions create",
                subject: "regions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRegions",
            component: EditRegions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions edit",
                subject: "regions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowRegions",
            component: ShowRegions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions show",
                subject: "regions",
              },
            },
          },
        ],
      },
      // End:: Regions Config

      // Start:: services  Config
      {
        path: "/services",
        name: "services",
        component: ServicesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allservices",
            component: AllServices,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services index",
                subject: "services",
              },
            },
          },
          {
            path: "create",
            name: "Createservices",
            component: CreateServices,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services create",
                subject: "services",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editservices",
            component: EditServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services edit",
                subject: "services",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showservices",
            component: ShowServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services show",
                subject: "services",
              },
            },
          },
        ],
      },
      // End:: services Config

      // Start:: reasons  Config
      {
        path: "/reasons",
        name: "reasons",
        component: ReasonsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allreasons",
            component: AllReasons,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons index",
                subject: "reasons",
              },
            },
          },
          {
            path: "create",
            name: "Createreasons",
            component: CreateReasons,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons create",
                subject: "reasons",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editreasons",
            component: EditReasons,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons edit",
                subject: "reasons",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showreasons",
            component: ShowReasons,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons show",
                subject: "reasons",
              },
            },
          },
        ],
      },
      // End:: reasons Config

      // Start:: workplaces  Config
      {
        path: "/workplaces",
        name: "workplaces",
        component: WorkplacesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allworkplaces",
            component: AllWorkplaces,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces index",
                subject: "workplaces",
              },
            },
          },
          {
            path: "create",
            name: "Createworkplaces",
            component: CreateWorkplaces,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces create",
                subject: "workplaces",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editworkplaces",
            component: EditWorkplaces,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces edit",
                subject: "workplaces",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showworkplaces",
            component: ShowWorkplaces,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces show",
                subject: "workplaces",
              },
            },
          },
        ],
      },
      // End:: workplaces Config

      // Start:: WalletRequests  Config
      {
        path: "/request-wallets",
        name: "RequestWallets",
        component: RequestWalletsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRequestWallets",
            component: AllRequestWallets,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "withdraw_requests index",
                subject: "withdraw_requests",
              },
            },
          },
        ],
      },
      // End:: WalletRequests Config

      // start::designers orders
      {
        path: "/user-requests",
        name: "UserRequestsHome",
        component: UserRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUserRequests",
            component: AllUserRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "acceptedproviders index",
                subject: "acceptedproviders",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowUserRequests",
            component: ShowUserRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "acceptedproviders show",
                subject: "acceptedproviders",
              },
            },
          },
        ],
      },
      // End::designers orders

      // Start:: WalletHistory  Config
      {
        path: "/WalletHistory",
        name: "WalletHistory",
        component: WalletHistoryHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all/:id",
            name: "AllWalletHistory",
            component: AllWalletHistory,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: WalletHistory Config

      // Start:: Providers  Config
      {
        path: "/providers",
        name: "Providers",
        component: ProvidersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllProviders",
            component: AllProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers index",
                subject: "providers",
              },
            },
          },
          {
            path: "create",
            name: "CreateProviders",
            component: CreateProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers create",
                subject: "providers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditProviders",
            component: EditProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers edit",
                subject: "providers",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowProviders",
            component: ShowProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers show",
                subject: "providers",
              },
            },
          },
        ],
      },
      // End:: Providers Config

      // Start:: Stables Config
      {
        path: "/stables",
        name: "Stables",
        component: StablesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllStables",
            component: AllStables,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "stables index",
                subject: "stables",
              },
            },
          },
          {
            path: "create",
            name: "CreateStables",
            component: CreateStables,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "stables create",
                subject: "stables",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditStables",
            component: EditStables,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "stables edit",
                subject: "stables",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowStables",
            component: ShowStables,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "stables show",
                subject: "stables",
              },
            },
          },
        ],
      },
      // End:: Stables Config

      // Start:: RoomRent Config
      {
        path: "/room-rent",
        name: "RoomRent",
        component: RoomRentHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRoomRent",
            component: AllRoomRent,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "room_rent index",
                subject: "room_rent",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowRoomRent",
            component: ShowRoomRent,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "room_rent show",
                subject: "room_rent",
              },
            },
          },
        ],
      },
      // End:: RoomRent Config

      // Start:: HorsePurchase Config
      {
        path: "/horse-purchase",
        name: "HorsePurchase",
        component: HorsePurchaseHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllHorsePurchase",
            component: AllHorsePurchase,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "horses index",
                subject: "horses",
              },
            },
          },
          {
            path: "show/:id",
            name: "HorsePurchaseShow",
            component: ShowHorsePurchase,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "horses show",
                subject: "horses",
              },
            },
          },
        ],
      },
      // End:: HorsePurchase Config

      // Start:: HorseRent Config
      {
        path: "/horse-rent",
        name: "HorseRent",
        component: HorseRentHome,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "horses index",
            subject: "horses",
          },
        },
        children: [
          {
            path: "all",
            name: "AllHorseRent",
            component: AllHorseRent,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "horses index",
                subject: "horses",
              },
            },
          },
          {
            path: "show/:id",
            name: "HorseRentShow",
            component: ShowHorseRent,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "horses show",
                subject: "horses",
              },
            },
          },
        ],
      },
      // End:: HorseRent Config

      // Start:: OtherService (Transport Cart Requests) Config
      {
        path: "/other-service",
        name: "OtherServiceHome",
        component: OtherServiceHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllOtherService",
            component: AllOtherService,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders index",
                subject: "orders",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowOtherService",
            component: ShowOtherService,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders show",
                subject: "orders",
              },
            },
          },
        ],
      },
      // End:: OtherService Config

      // Start:: ProductOrders (Stores & Supplies Orders) Config
      {
        path: "/product-orders",
        name: "ProductOrdersHome",
        component: ProductOrdersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllProductOrders",
            component: AllProductOrders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders index",
                subject: "orders",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowProductOrders",
            component: ShowProductOrders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders show",
                subject: "orders",
              },
            },
          },
        ],
      },
      // End:: ProductOrders Config
      // Start:: CarrierServiceHome (Transport Cart Requests) Config
      {
        path: "/carrier-service",
        name: "CarrierServiceHome",
        component: CarrierServiceHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCarrierService",
            component: AllCarrierService,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders index",
                subject: "orders",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCarrierService",
            component: ShowCarrierService,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders show",
                subject: "orders",
              },
            },
          },
        ],
      },
      // End:: CarrierServiceHome Config

      // Start:: chosen  Config
      {
        path: "/chosen",
        name: "chosen",
        component: ChosenHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allchosen",
            component: AllChosen,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "selectedproviders index",
                subject: "selectedproviders",
              },
            },
          },
          {
            path: "create",
            name: "Createchosen",
            component: CreateChosen,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "selectedproviders create",
                subject: "selectedproviders",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editchosen",
            component: EditChosen,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "selectedproviders edit",
                subject: "selectedproviders",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showchosen",
            component: ShowChosen,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "selectedproviders show",
                subject: "selectedproviders",
              },
            },
          },
        ],
      },
      // End:: Providers Config

      // Start:: banks  Config
      // {
      //   path: "/banks",
      //   name: "banks",
      //   component: BanksHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allbanks",
      //       component: AllBanks,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "banks index",
      //           subject: "banks",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Createbanks",
      //       component: CreateBanks,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "banks create",
      //           subject: "banks",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editbanks",
      //       component: EditBanks,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "banks edit",
      //           subject: "banks",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showbanks",
      //       component: ShowBanks,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "banks show",
      //           subject: "banks",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: banks Config

      // Start:: packages  Config
      {
        path: "/packages",
        name: "packages",
        component: PackagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allpackages",
            component: AllPackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages index",
                subject: "packages",
              },
            },
          },
          {
            path: "create",
            name: "Createpackages",
            component: CreatePackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages create",
                subject: "packages",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editpackages",
            component: EditPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages edit",
                subject: "packages",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showpackages",
            component: ShowPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages show",
                subject: "packages",
              },
            },
          },
        ],
      },
      // End:: packages Config

      // Start:: subscriptions  Config
      {
        path: "/subscriptions",
        name: "subscriptions",
        component: SubscriptionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allsubscriptions",
            component: AllSubscriptions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subscriptions index",
                subject: "subscriptions",
              },
            },
          },
        ],
      },
      // End:: subscriptions Config

      // Start:: ads  Config
      {
        path: "/ads",
        name: "ads",
        component: AdsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAds",
            component: AllAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements index",
                subject: "advertisements",
              },
            },
          },
          {
            path: "create",
            name: "CreateAds",
            component: CreateAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements create",
                subject: "advertisements",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAds",
            component: EditAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements edit",
                subject: "advertisements",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAds",
            component: ShowAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements show",
                subject: "advertisements",
              },
            },
          },
        ],
      },
      // End:: ads Config

      // Start:: All Notifications Route Config
      {
        path: "/all-notifications",
        name: "NotificationsHome",
        component: NotificationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllNotifications",
            component: AllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "create",
            name: "CreateNotificationss",
            component: CreateNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications create",
                subject: "notifications",
              },
            },
          },
          {
            path: "show",
            name: "ShowAllNotifications",
            component: ShowAllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowNotificationss",
            component: ShowNotificationsTable,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
        ],
      },
      // End:: All Notifications Route Config

      // Start:: Clients Routes Config
      {
        path: "/Clients",
        name: "ClientsHome",
        component: ClientsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllClients",
            component: AllClients,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowClients",
            component: ShowClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users show",
                subject: "users",
              },
            },
          },
          {
            path: "create",
            name: "CreateClients",
            component: CreateClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users show",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: Clients Routes

      // Start:: Owners Routes Config
      {
        path: "/owners",
        name: "OwnersHome",
        component: OwnersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllOwners",
            component: AllOwners,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "owners index",
                subject: "owners",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowOwners",
            component: ShowOwners,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "owners show",
                subject: "owners",
              },
            },
          },
          {
            path: ":id/horses",
            name: "OwnerHorses",
            component: () => import("@/views/Cruds/Owners/Horses.vue"),
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "owners show",
                subject: "owners",
              },
            },
          },
        ],
      },
      // End:: Owners Routes

      // Start:: Workers Routes Config
      {
        path: "/Workers",
        name: "WorkersHome",
        component: WorkersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllWorkers",
            component: AllWorkers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workers index",
                subject: "workers",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowWorkers",
            component: ShowWorkers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workers show",
                subject: "workers",
              },
            },
          },
          {
            path: "create",
            name: "CreateWorkers",
            component: CreateWorkers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workers show",
                subject: "workers",
              },
            },
          },
        ],
      },
      // End:: Workers Routes

      // Start:: DeliveryMen Routes Config
      {
        path: "/DeliveryMen",
        name: "DeliveryMenHome",
        component: DeliveryMenHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllDeliveryMen",
            component: AllDeliveryMen,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "deliveries index",
                subject: "deliveries",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditDeliveryMen",
            component: EditDeliveryMen,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "deliveries edit",
                subject: "deliveries",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowDeliveryMen",
            component: ShowDeliveryMen,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "deliveries show",
                subject: "deliveries",
              },
            },
          },
          {
            path: "create",
            name: "CreateDeliveryMen",
            component: CreateDeliveryMen,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "deliveries show",
                subject: "deliveries",
              },
            },
          },
        ],
      },
      // End:: DeliveryMen Routes Config

      // Start:: Sliders Routes Config
      {
        path: "/sliders",
        name: "SlidersHome",
        component: SlidersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSliders",
            component: AllSliders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders index",
                subject: "sliders",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSliders",
            component: EditSliders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders edit",
                subject: "sliders",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowSliders",
            component: ShowSliders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders show",
                subject: "sliders",
              },
            },
          },
          {
            path: "create",
            name: "CreateSliders",
            component: CreateSliders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders show",
                subject: "sliders",
              },
            },
          },
        ],
      },
      // End:: Sliders Routes Config

      // Start:: Order requests config
      {
        path: "/order-requests",
        name: "OrdersRequestsHome",
        component: OrdersRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllOrdersRequests",
            component: AllOrdersRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowOrdersRequests",
            component: ShowOrdersRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: Order requests config

      // Start:: questions Routes Config
      {
        path: "/questions",
        name: "questionsHome",
        component: questionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allquestions",
            component: Allquestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions index",
                subject: "questions",
              },
            },
          },
          {
            path: "create",
            name: "Createquestions",
            component: Createquestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions create",
                subject: "questions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editquestions",
            component: Editquestions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions edit",
                subject: "questions",
              },
            },
          },
        ],
      },
      // End:: questions Routes Config
      {
        path: "/branches",
        name: "branches",
        component: BranchesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllBranches",
            component: AllBranches,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "branches index",
                subject: "branches",
              },
            },
          },
          {
            path: "create",
            name: "CreateBranches",
            component: CreateBranches,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "branches create",
                subject: "branches",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditBranches",
            component: EditBranches,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "branches edit",
                subject: "branches",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowBranches",
            component: ShowBranches,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "branches show",
                subject: "branches",
              },
            },
          },
        ],
      },
      // Start:: update_delivery Routes Config
      {
        path: "/update_delivery",
        name: "update_deliveryHome",
        component: update_deliveryHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allupdate_delivery",
            component: Allupdate_delivery,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "updatedeliveryrequests index",
                subject: "updatedeliveryrequests",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showupdate_delivery",
            component: Showupdate_delivery,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "updatedeliveryrequests index",
                subject: "updatedeliveryrequests",
              },
            },
          },
        ],
      },
      // End:: update_delivery Config
      // Start:: Showupdate_provider Routes Config
      {
        path: "/update_provider",
        name: "update_providerHome",
        component: update_providerHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allupdate_provider",
            component: Allupdate_provider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "updateproviderrequests index",
                subject: "updateproviderrequests",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showupdate_provider",
            component: Showupdate_provider,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "updateproviderrequests index",
                subject: "updateproviderrequests",
              },
            },
          },
        ],
      },
      // End:: Showupdate_provider Config
      // Start:: JoinProviders Routes Config
      {
        path: "/join_providers",
        name: "join_providersHome",
        component: join_providersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alljoin_providers",
            component: Alljoin_providers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "joinproviders index",
                subject: "joinproviders",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showjoin_providers",
            component: Showjoin_providers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "joinproviders index",
                subject: "joinproviders",
              },
            },
          },
        ],
      },
      // End:: JoinProviders Config
      // Start:: JoinStables Routes Config
      {
        path: "/join_stables",
        name: "join_stablesHome",
        component: join_stablesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alljoin_stables",
            component: Alljoin_stables,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "stables index",
                subject: "stables",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showjoin_stables",
            component: Showjoin_stables,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "stables show",
                subject: "stables",
              },
            },
          },
        ],
      },
      // End:: JoinStables Config
      // Start:: JoinDeliveries Routes Config
      {
        path: "/join_deliveries",
        name: "join_deliveriesHome",
        component: join_deliveriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alljoin_deliveries",
            component: Alljoin_deliveries,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "joindeliveries index",
                subject: "joindeliveries",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showjoin_deliveries",
            component: Showjoin_deliveries,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "joindeliveries index",
                subject: "joindeliveries",
              },
            },
          },
        ],
      },
      // End:: Join Deliveries Config

      // Start:: Categories Routes Config
      {
        path: "/stores-categories",
        name: "CategoriesHome",
        component: CategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCategories",
            component: AllCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "create",
            name: "CreateCategories",
            component: CreateCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCategories",
            component: EditCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCategories",
            component: ShowCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
        ],
      },
      // End:: Categories Routes Config

      // Start:: Colors Routes Config
      {
        path: "/colors",
        name: "ColorsHome",
        component: ColorsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllColors",
            component: AllColors,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "colors index",
                subject: "colors",
              },
            },
          },
          {
            path: "create",
            name: "CreateColors",
            component: CreateColors,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "colors index",
                subject: "categories",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditColors",
            component: EditColors,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "colors index",
                subject: "colors",
              },
            },
          },
        ],
      },
      // End:: Colors Routes Config

      // Start:: Breeds Routes Config
      {
        path: "/breeds",
        name: "BreedsHome",
        component: BreedsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllBreeds",
            component: AllBreeds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "breeds index",
                subject: "breeds",
              },
            },
          },
          {
            path: "create",
            name: "CreateBreeds",
            component: CreateBreeds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "breeds index",
                subject: "breeds",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditBreeds",
            component: EditBreeds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "breeds index",
                subject: "breeds",
              },
            },
          },
        ],
      },
      // End:: Breeds Routes Config

      // Start:: Service Types Requests Routes Config
      {
        path: "/service_types_requests",
        name: "ServiceTypesRequestsHome",
        component: ServiceTypesRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllServiceTypesRequests",
            component: AllServiceTypesRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providertypes index",
                subject: "providertypes",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowServiceTypesRequests",
            component: ShowServiceTypesRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providertypes index",
                subject: "providertypes",
              },
            },
          },
        ],
      },
      // End:: Service Types Requests Routes Config

      // Start:: Service Types Routes Config
      {
        path: "/service_types",
        name: "ServiceTypesHome",
        component: ServiceTypesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllServiceTypes",
            component: AllServiceTypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providertypes index",
                subject: "providertypes",
              },
            },
          },
          {
            path: "create",
            name: "CreateServiceTypes",
            component: CreateServiceTypes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providertypes index",
                subject: "providertypes",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditServiceTypes",
            component: EditServiceTypes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providertypes index",
                subject: "providertypes",
              },
            },
          },
        ],
      },
      // End:: Service Types Routes Config

      // Start:: app-rates Routes Config
      {
        path: "/app-rate",
        name: "AppRatesHome",
        component: AppRatesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAppRates",
            component: AllAppRates,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "rates index",
                subject: "rates",
              },
            },
          },
        ],
      },
      // End:: app-rates Routes Config

      // Start:: app-rates Routes Config
      {
        path: "/store-rate",
        name: "StoreRatesHome",
        component: StoreRatesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllStoreRates",
            component: AllStoreRates,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "rates index",
                subject: "rates",
              },
            },
          },
        ],
      },
      // End:: app-rates Routes Config

      // Start:: sub Categories Routes Config
      {
        path: "/sub-categories",
        name: "CategoriesHome",
        component: SubCategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSubCategories",
            component: AllSubCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subcategories index",
                subject: "subcategories",
              },
            },
          },
          {
            path: "create",
            name: "CreateSubCategories",
            component: CreateSubCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subcategories index",
                subject: "subcategories",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSubCategories",
            component: EditSubCategories,
            props: true,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "show/:id",
            name: "ShowSubCategories",
            component: ShowSubCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subcategories index",
                subject: "subcategories",
              },
            },
          },
        ],
      },
      // End:: sub Categories Routes Config

      // Start:: management Routes Config
      {
        path: "/managements",
        name: "ManagementsHome",
        component: ManagementsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllManagements",
            component: AllManagements,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "management index",
                subject: "management",
              },
            },
          },
          {
            path: "create",
            name: "CreateManagements",
            component: CreateManagements,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "management index",
                subject: "management",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditManagements",
            component: EditManagements,
            props: true,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "show/:id",
            name: "ShowManagements",
            component: ShowManagements,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "management index",
                subject: "management",
              },
            },
          },
        ],
      },
      // End:: management Routes Config

      // Start:: Capacities  Config
      {
        path: "/Capacities",
        name: "CapacitiesHome",
        component: CapacitiesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCapacitiesHome",
            component: AllCapacities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities index",
                subject: "capacities",
              },
            },
          },
          {
            path: "create",
            name: "CreateCapacities",
            component: CreateCapacities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities create",
                subject: "capacities",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCapacities",
            component: EditCapacities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities edit",
                subject: "capacities",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCapacities",
            component: ShowCapacities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities show",
                subject: "capacities",
              },
            },
          },
        ],
      },
      // End:: Capacities Config
      // Start:: Additions  Config
      {
        path: "/Additions",
        name: "AdditionsHome",
        component: AdditionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdditionsHome",
            component: AllAdditions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions index",
                subject: "additions",
              },
            },
          },
          {
            path: "create",
            name: "CreateAdditions",
            component: CreateAdditions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions create",
                subject: "additions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAdditions",
            component: EditAdditions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions edit",
                subject: "additions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAdditions",
            component: ShowAdditions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions show",
                subject: "additions",
              },
            },
          },
        ],
      },
      // End:: Additions Config

      // Start:: App contact Routes Config
      {
        path: "/contact_settings",
        component: GeneralSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings create",
            subject: "settings",
          },
        },
      },
      {
        path: "/app_settings",
        component: AppSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings edit",
            subject: "settings",
          },
        },
      },
      // End:: App contact Routes Config
    ],
  },
  // ***************** End:: Content Routes Config

  // ***************** Start:: Forbidden Route Config
  {
    path: "/forbidden",
    name: "ForbiddenPage",
    component: ForbiddenPage,
  },
  // ***************** End:: Forbidden Route Config

  // ***************** Start:: Not Found Route Config
  {
    path: "/:notFound(.*)",
    name: "NotFoundPage",
    component: NotFoundPage,
  },
  // ***************** End:: Not Found Route Config
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  routes,
});

// Start:: Middleware And Router Guards
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

// Authentication and Permission Check Middleware
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem(
    "linate_admin_dashboard_user_token"
  );

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, router, to };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  } else if (isAuthenticated) {
    const publicRoutes = [
      "LoginForm",
      "ResetPasswordEmailForm",
      "PhoneVerification",
      "ChangePhoneNumberForm",
      "ResetPasswordForm",
    ];

    if (publicRoutes.includes(to.name)) {
      return next("/home");
    }
  }

  if (to.meta.requiresPermission) {
    const { action, subject } = to.meta.requiresPermission;
    const storedPermissions = JSON.parse(
      localStorage.getItem("linate_admin_roles")
    )?.permissions;

    if (
      storedPermissions &&
      storedPermissions.some(
        (permission) =>
          permission.action === action && permission.subject === subject
      )
    ) {
      return next();
    } else {
      return next("/forbidden");
    }
  }

  return next();
});

export default router;
